

























import { Component, Vue, PropSync, Prop, Watch } from 'vue-property-decorator';
import { Dialog, Button, Form, FormItem, RadioButton, RadioGroup } from 'element-ui';
import Project from '@/models/project';
import SheetLayer from '../models/sheet-layer';
import { MessageBoxInputData } from 'element-ui/types/message-box';

@Component({
  components: {
    'el-dialog': Dialog,
    'el-button': Button,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-radio-group': RadioGroup,
    'el-radio-button': RadioButton,
  },
})
export default class SettingsDialog extends Vue {
  @PropSync('showDialog', { type: Boolean, default: false }) private show!: boolean;
  private settings: any = {
    sheetCorner: {
      coordinateSystem: 'wgs84',
      utmSpan: 6,
    },
  };

  private handleSave(): void {
    localStorage.setItem('settings', JSON.stringify(this.settings));
    this.show = false;
  }

  @Watch('show')
  private loadSettings(): void {
    const savedSetttings = localStorage.getItem('settings');
    if (savedSetttings) {
      this.settings = JSON.parse(savedSetttings);
    }
  }
}
